import { api } from "@/services/api";
import { DeleteResponse } from "@/types";
import { AddMargin, Margin, UpdateMargin } from "@/types/margin";

export class MarginRepository {
  async findAll(): Promise<Array<Margin>> {
    const response = await api.get(`/v1/margins`);

    return response.data;
  }

  async add(data: AddMargin): Promise<Margin> {
    const response = await api.post("/v1/margins", data);

    return response.data;
  }

  async update(data: UpdateMargin): Promise<Margin> {
    const { id, ...payload } = data;
    const response = await api.patch(`/v1/margins/${id}`, payload);

    return response.data;
  }

  async delete(id: string): Promise<DeleteResponse> {
    const response = await api.delete(`/v1/margins/${id}`);

    return response.data;
  }
}
